/**
 * ChatContainer Component
 * Displays the chat messages
 */

import React, { forwardRef } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';  // Added Typography
import Message from './Message';

const ChatContainer = forwardRef(({ messages, onSendMessage }, ref) => {
  const exampleQuestions = [
    "What can you help me with?",
    "Which funding sources are projected to over-obligate?",
    "Can I use Program Appropriated dollars for IT Spend?",
    "What are the legal considerations for moving funds?",
  ];

  return (
    <Box
      ref={ref}
      sx={{
        flexGrow: 1,
        overflow: 'auto',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: '#fafafa',
      }}
    >
      {messages.length === 0 ? (
        <Box sx={{ 
          textAlign: 'center', 
          color: 'text.secondary',
          mt: 4 
        }}>
          <h2>Welcome to GIBS Guru 2.0</h2>
          <p style={{ color: '#666', fontSize: '0.9rem' }}>
            This is an AI-powered assistant. Always verify critical information before making decisions.
          </p>
          <p>Ask me questions about GIBS data, budget regulations, or both. I can visualize results, export data to Excel, and generate PowerPoint reports using default or uploaded templates.</p>
          
          <Box sx={{ mt: 3 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Try one of these example questions:
            </Typography>
            <Stack spacing={1} alignItems="center">
              {exampleQuestions.map((question, index) => (
                <Button
                  key={index}
                  variant="outlined"
                  size="small"
                  onClick={() => onSendMessage(question)}
                  sx={{ 
                    maxWidth: 400,
                    textTransform: 'none',
                    justifyContent: 'flex-start'
                  }}
                >
                  {question}
                </Button>
              ))}
            </Stack>
          </Box>
        </Box>
      ) : (
        messages.map((message) => (
          <Message key={message.id} message={message} />
        ))
      )}
    </Box>
  );
});

ChatContainer.displayName = 'ChatContainer';

export default ChatContainer;